import React from 'react';
import PropTypes from 'prop-types';
function CloudOutlineIcon({ width, height, color, style }) {
  return (
    <svg
      style={style}
      width={width}
      height={height}
      viewBox="0 0 20 18"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xlink="http://www.w3.org/1999/xlink"
    >
      <desc>Created with sketchtool.</desc>
      <g
        id="🌈-Style"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g
          id="Icons"
          transform="translate(-542.000000, -121.000000)"
          fill={color}
          fillRule="nonzero"
        >
          <g id="Colors-Copy" transform="translate(22.000000, 20.000000)">
            <path
              d="M530.219772,107.054996 C530.288829,107.090455 530.351481,107.142266 530.404249,107.207503 L532.825704,110.201888 C533.052507,110.472649 533.058772,110.9195 532.839766,111.199901 C532.620621,111.480474 532.259185,111.48822 532.032382,111.217286 L532.01832,111.199901 L532.01832,111.199901 L530.570905,109.409915 L530.570905,118.294092 C530.570905,118.683968 530.315282,119 529.99993,119 C529.684718,119 529.429095,118.683968 529.429095,118.294092 L529.429095,109.409743 L527.98168,111.199901 C527.762535,111.480474 527.401099,111.48822 527.174296,111.217286 C526.947493,110.946525 526.941228,110.499674 527.160234,110.219273 L527.174296,110.201888 L527.174296,110.201888 L529.595751,107.207503 C529.648519,107.142266 529.711171,107.090455 529.780228,107.054996 C529.92071,106.981668 530.07929,106.981668 530.219772,107.054996 Z M528.792094,101.124002 C532.181357,100.436884 535.476473,102.674557 536.151976,106.122099 C538.338547,106.394338 539.986182,108.276114 540,110.516891 C540.014868,112.977448 538.066027,114.984633 535.647065,115 L535.647065,115 L532.518269,115 C532.172659,115 531.892509,114.715032 531.892509,114.36348 C531.892509,114.011927 532.172659,113.72696 532.518269,113.72696 L532.518269,113.72696 L535.646913,113.72696 C537.37496,113.72696 538.775709,112.302125 538.775709,110.544519 C538.775709,108.786757 537.37496,107.361922 535.646913,107.361922 C535.320071,107.364095 535.040532,107.123674 534.988042,106.795403 C534.721015,104.446754 532.899584,102.594003 530.590637,102.322384 C527.844224,101.999235 525.36026,104.00192 525.042574,106.795558 C525.007479,107.117931 524.739536,107.362077 524.420629,107.361922 C522.692581,107.351678 521.283593,108.768132 521.27337,110.525738 C521.263146,112.283345 522.655655,113.716561 524.383703,113.72696 L524.383703,113.72696 L527.512347,113.72696 C527.857957,113.72696 528.138106,114.011927 528.138106,114.36348 C528.138106,114.715032 527.857957,115 527.512347,115 L527.512347,115 L524.383703,115 C522.157306,115.001551 520.283996,113.304166 520.029175,111.054386 C519.752382,108.609817 521.476158,106.399926 523.879251,106.118218 C524.374853,103.596975 526.313166,101.626574 528.792094,101.124002 Z"
              id="ic_load_cloud_up_outline"
            ></path>
          </g>
        </g>
      </g>
    </svg>
  );
}

CloudOutlineIcon.propTypes = {
  width: PropTypes.string,
  height: PropTypes.string,
  color: PropTypes.string
};

CloudOutlineIcon.defaultProps = {
  width: '20px',
  height: '18px',
  color: '#0B0E12'
};

export default CloudOutlineIcon;
